import { render, staticRenderFns } from "./MatterDefendantList.vue?vue&type=template&id=2c8555e8&"
import script from "./MatterDefendantList.vue?vue&type=script&lang=js&"
export * from "./MatterDefendantList.vue?vue&type=script&lang=js&"
import style0 from "./MatterDefendantList.vue?vue&type=style&index=0&id=2c8555e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports